import { EmbeddedMessageMedium } from 'constants/messageMediums';
import {
  selectIsEmbeddedMessagingCoreFeatureFlagOn,
  selectUserRbacPermissions,
} from 'core/userContext';
import { useCreateCampaignContext } from 'modules/campaignIndex/campaignFolders/contexts/CreateCampaignContext';
import { MEDIUM_OPTIONS } from 'modules/quickActionsMenu/constants';
import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { PAGE } from 'modules/quickActionsMenu/types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { Item } from '../Item';
import { CommandEmpty, CommandGroup, CommandList } from '../Styled';

const CampaignMediumsGated = () => {
  const { setMessageMedium } = useCreateCampaignContext();
  const { pageState, selectPage } = useQuickActionsMenuContext();
  const isEmbeddedMessagingCoreEnabled = useSelector(selectIsEmbeddedMessagingCoreFeatureFlagOn);

  const campaignMediumOptions = Object.values(MEDIUM_OPTIONS).filter((option) =>
    !isEmbeddedMessagingCoreEnabled ? option.id !== EmbeddedMessageMedium.Embedded : option,
  );

  return (
    <CommandList>
      <CommandEmpty>No matching results</CommandEmpty>
      <CommandGroup heading="Campaign mediums">
        {campaignMediumOptions.map((medium) => {
          const { Icon, id, label, slug } = medium;
          return (
            <Item
              Icon={<Icon />}
              key={id}
              name={label}
              onSelect={() => {
                setMessageMedium(slug);
                selectPage({ page: PAGE.CAMPAIGN_CREATION, previousPage: pageState?.page });
              }}
              value={label}
            />
          );
        })}
      </CommandGroup>
    </CommandList>
  );
};

export const CampaignMediums = () => {
  const permissions = useSelector(selectUserRbacPermissions);
  const hasCampaignPermissions = useMemo(
    () => permissions.includes(PROJECT_PERMISSIONS.DraftMessaging),
    [permissions],
  );

  return (
    <>
      {hasCampaignPermissions ? (
        <CampaignMediumsGated />
      ) : (
        <CommandEmpty>User does not have the required permissions</CommandEmpty>
      )}
    </>
  );
};
